import { combineReducers } from 'redux';
import userAuth from './userAuth';
import uiSettings from './ui';
import sensors from './sensors';
import locations from './location';

export default combineReducers({ userAuth, uiSettings, sensors, locations });
